import React, { useEffect, useState } from 'react';
import styles from '../news-tab/NewsTab.module.scss';
import { useGetQuery } from '../../../../../../services/apiCall';
import NewsCard from '../../../../../atoms/newsCard/NewsCard';
import endpoints from '../../../../../../api/endpoints';
import Text from '../../../../../atoms/text/Text';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../../atoms/loader/Loader';
import useIsRtl from '../../../../../../app/helpers/isRtl';

const EventsTab = () => {
  const navigate = useNavigate();
  const isRtl = useIsRtl();
  const apiUrl = endpoints.news.getEvents;
  const params = ['4', '1', '?IsActive=true'];
  const { data, error, isLoading } = useGetQuery({
    apiUrl: apiUrl,
    params: params,
  });

  const [delayDone, setDelayDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setDelayDone(true), 500);
    return () => clearTimeout(timer);
  }, []);

  if (error) return <p>Something went wrong</p>;

  return (
    <div className={styles['cards-container']}>
      {!delayDone || isLoading ? (
        <div className={styles['loader-container']}>
          <Loader />
        </div>
      ) : (
        <>
          <div className={styles.cards} dir={isRtl ? 'rtl' : ''}>
            {data?.items?.map((item) => (
              <NewsCard
                key={item?.eventId}
                id={item?.eventId}
                image={`${item?.url}${item?.image1}`}
                date={item?.eventDate}
                title={item?.title_EN ?? item?.title_AR}
                description={item?.eventText_EN ?? item?.eventText_AR}
                link={`/news-and-events/events/event-${item?.eventId}`}
                type="events"
                className={styles.card}
              />
            ))}
          </div>
          <div className={styles['view-container']}>
            <button
              className={styles['view-btn']}
              onClick={() => navigate('/news-and-events/events')}
            >
              <Text
                title="common.view_all"
                variant="text-bold-italic-16"
                maxLines={2}
                className={styles.btnTitle}
              />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EventsTab;
